export class WordCloudSetting {
    wordCountThreshold: number;
    font: string;
    maxCountPerColor: number;
    exceptionWords: string;
    maxWordCount: number;
    dateCreated: string;
}


// WEBPACK FOOTER //
// ./src/app/models/settings/word-cloud-setting.ts